// Libraries
var React = require('react');
var $ = require('jquery');

// Assets
var spinner = require('../../common/images/Rolling.svg');
var PlaceholderImg = require('images/blankImgPlaceholder.png');

// Styles
require('./LeagueTable.scss');

// Components 
var CallToAction = require('../../common/CallToAction/CallToAction');

class LeagueTableModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			table: [],
			teams: [],
			records: [],
			isLoading: true
		}
	}

	componentDidMount() {
		this.loadData();
	}

	loadData = () => {
		$.ajax({
			method: "GET",
			url: this.props.data.endpoints.find(x => x.name === "leagueTable").url
		})
			.done(data => {
				this.populateData(data);
			})
			.fail(data => {
				this.setState({ isLoading: false });
			});
	}

	populateData = (data) => {
		let teamRecord = this.props.data.tableName &&  data.soccerDocument.competition.teamStandings.length > 1 ? 
			data.soccerDocument.competition.teamStandings.find(x => x.round.name == this.props.data.tableName).teamRecord
			: data.soccerDocument.competition.teamStandings[0].teamRecord;

		this.setState({ 
			records: teamRecord, 
			teams: data.soccerDocument.team,
			isLoading: false
		});
	}

	getTeamName = (id) => {
		let team = this.state.teams.filter(x => x.uid == id);
		return (<span className="LeagueTable__cell--longname">{team.length > 0 ? team[0].name : ""}</span>);
	}

	render() {
		return (
			<div className="LeagueTable">
				<div className="LeagueTable__wrapper">
					{this.state.isLoading &&
							<img src={spinner} className="spinner" alt="Loading animation" />
					}
					{!this.state.isLoading && this.state.records.length === 0 &&
							<p>No league data is available</p>
					}
					{this.state.records.length > 0 &&
							<div>
								<table>
									<thead>
										<tr>
											<th className="LeagueTable__cell"><abbr title="Position">Pos</abbr></th>
											<th className="LeagueTable__cell">Team</th>
											<th className="LeagueTable__cell"><abbr title="Played">Pld</abbr></th>
											<th className="LeagueTable__cell"><abbr title="Win">W</abbr></th>
											<th className="LeagueTable__cell"><abbr title="Draw">D</abbr></th>
											<th className="LeagueTable__cell"><abbr title="Loss">L</abbr></th>
											<th className="LeagueTable__cell LeagueTable__cell--desktop"><abbr title="Goal for">GF</abbr></th>
											<th className="LeagueTable__cell LeagueTable__cell--desktop"><abbr title="Goal against">GA</abbr></th>
											<th className="LeagueTable__cell LeagueTable__cell--desktop"><abbr title="Goal difference">GD</abbr></th>
											<th className="LeagueTable__cell"><abbr title="Points">Pts</abbr></th>
										</tr>
									</thead>
									<tbody>
										{this.state.records.length > 0 && this.state.records.map((element, index) => {
											let isSpurs = this.props.data.siteTeamOptaId === element.teamRef.toString();
											return(
												<tr key={index} data-optaid={element.teamRef} className={"LeagueTable__row" + (isSpurs ? " LeagueTable__row--highlight" : "")}>
													<td className="LeagueTable__cell">
														{element.standing.position}
													</td>
													<td className="LeagueTable__cell">
														<div className="LeagueTable__cell--image">
															<img src={PlaceholderImg} data-src={this.props.data.baseUrl + element.teamRef + ".png"} alt="" />
														</div>
														<div className="LeagueTable__cell--team">
															{this.getTeamName(element.teamRef)}
														</div>
													</td>
													<td className="LeagueTable__cell">{element.standing.played}</td>
													<td className="LeagueTable__cell">{element.standing.won}</td>
													<td className="LeagueTable__cell">{element.standing.drawn}</td>
													<td className="LeagueTable__cell">{element.standing.lost}</td>
													<td className="LeagueTable__cell LeagueTable__cell--desktop">{element.standing.for}</td>
													<td className="LeagueTable__cell LeagueTable__cell--desktop">{element.standing.against}</td>
													<td className="LeagueTable__cell LeagueTable__cell--desktop">{element.standing.for - element.standing.against}</td>
													<td className="LeagueTable__cell">{element.standing.points}</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
					}
					{this.state.records.length > 0 && this.props.data.loadMoreLink &&
							<CallToAction button={true} {...this.props.data.loadMoreLink} />
					}
				</div>
			</div>
		)
	}
}

module.exports = LeagueTableModule;



// WEBPACK FOOTER //
// ./src/components/LeagueTable/LeagueTableModule.js